/* SAM cart drawer - header sync (Horizon-versie).
   Werkt het telbolletje naast het winkelwagen-icoon in de Horizon-header bij
   (snippets/cart-bubble.liquid + header-actions.liquid).
   Luistert naar het ajaxCart-event dat sam-cart.js na elke wijziging stuurt. */
(function () {
  var cfg = window.SAMCart || {};
  var pending = null;

  function apply(cart) {
    var count = cart.item_count || 0;
    var i, els;

    els = document.querySelectorAll(".cart-bubble");
    for (i = 0; i < els.length; i++) {
      els[i].classList.toggle("visually-hidden", count === 0);
      if (count <= 99) { els[i].setAttribute("data-maintain-ratio", ""); } else { els[i].removeAttribute("data-maintain-ratio"); }
    }

    els = document.querySelectorAll(".cart-bubble__text-count");
    for (i = 0; i < els.length; i++) {
      els[i].textContent = count >= 100 ? "" : String(count);
      els[i].classList.toggle("hidden", count === 0);
    }

    els = document.querySelectorAll(".header-actions__cart-icon");
    for (i = 0; i < els.length; i++) {
      els[i].classList.toggle("header-actions__cart-icon--has-cart", count > 0);
    }

    /* Oude Theme Syncer-haakjes, voor het geval ze ergens nog staan */
    var c = document.getElementById("cart-count");
    if (c) { c.textContent = count; }
  }

  function sync() {
    if (pending) { clearTimeout(pending); }
    pending = setTimeout(function () {
      var url = (cfg.routes && cfg.routes.cart_js) ? cfg.routes.cart_js : "/cart.js";
      fetch(url, { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(apply)
        .catch(function () {});
    }, 60);
  }

  document.addEventListener("ajaxCart", sync);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }
})();